import {MenuItemActionBase} from "../menu-item-action-base";
import {IServiceFactoryExtended} from "../../service-factory-extended.interface";
import {IMenuItemConfigReader} from "../../menu-items-common/menu-item-config-reader/menu-item-config-reader.interface";

export default class InstallPwaAction extends MenuItemActionBase {
    constructor(configReader: IMenuItemConfigReader, services: IServiceFactoryExtended) {
        super("installPWAMenuItem", configReader, services);
    }

    protected async _onClick(): Promise<void> {
        await this.services.progressiveWebApp.prompt();
    }
}